import viewCar1 from '/public/siteImages/iOSTheme/viewCar/viewCar1.png';
import viewCar2 from '/public/siteImages/iOSTheme/viewCar/viewCar2.png';
import viewCar3 from '/public/siteImages/iOSTheme/viewCar/viewCar3.png';
import viewCar4 from '/public/siteImages/iOSTheme/viewCar/viewCar4.png';

export {
    viewCar1,
    viewCar2,
    viewCar3,
    viewCar4
}